import { Pipe, PipeTransform } from '@angular/core';
import { EmailBoxFooterMode } from '../models/email-box-footer-mode.type';

@Pipe({
  name: 'appIsFooterModeActive'
})
export class GenesysIsFooterModeActivePipe implements PipeTransform {
  transform(currentFooterMode: EmailBoxFooterMode, checkFooterMode: EmailBoxFooterMode): boolean {
    return currentFooterMode === checkFooterMode;
  }
}
